import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import classes from "./OnlyPic.module.css";
import waitingPic from "../../assets/gifs/loading-spinner.gif";
import svgBack from "../../assets/SVGs/back.svg";
import toast from "react-hot-toast";

function OnlyPic() {
  const [image, setImage] = useState(null);
  const [picLoaded, setPicLoaded] = useState(false);
  const token = localStorage.getItem("token");
  const [showNavigation, setShowNavigation] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const address = location.state.Address;
  const parent = location.state.Parent;

  useEffect(() => {
    fetchImage();
  }, [address]);

  function fetchImage() {
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);

    fetch(address, { headers })
      .then((response) => response.blob())
      .then((blob) => {
        const imageUrl = URL.createObjectURL(blob);
        setImage(imageUrl);
        setPicLoaded(true);
        setShowNavigation(true);
      })
      .catch((error) => {
        toast.error("خطا در نمایش تصویر لطفا مجددا تلاش نمایید");
      });
  }

  var runonce = false;
  window.onpopstate = () => {
    if (!runonce) {
      navigate(-1);
      runonce = true;
    }
  };

  return (
    <div className={classes.main}>
      <div className={classes.header}>
        {showNavigation && (
          <div
            className={classes.return}
            onClick={() => {
              navigate(-1);
            }}
          >
            <img src={svgBack} className={classes.svg} alt="Back" />
          </div>
        )}

        <div className={classes.route}>{parent}</div>
      </div>
      {picLoaded ? (
        <div className={classes.zoomWrapper}>
          <TransformWrapper>
            <TransformComponent>
              <img src={image} className={classes.image} alt="Loaded" />
            </TransformComponent>
          </TransformWrapper>
        </div>
      ) : (
        <div className={classes.loader}>
          {/* <img src={waitingPic} alt="Loading..." /> */}
        </div>
      )}
    </div>
  );
}

export default OnlyPic;
